// API utility for making requests
// Supports both local development and Cloudflare Pages with Worker binding

const getApiUrl = () => {
  // In Cloudflare Pages, always use relative URLs (middleware handles routing)
  // This works for both local dev (with proxy) and production (with Worker binding)
  return '';
};

export const API_BASE_URL = getApiUrl();

// Configure axios base URL
export const configureAxios = (axios) => {
  // Always use relative URLs - middleware will handle routing
  // For local dev: React proxy handles /api/* requests
  // For production: Pages Functions middleware forwards to Worker
  axios.defaults.baseURL = '';
  
  // Set default headers
  axios.defaults.headers.common['Content-Type'] = 'application/json';
  
  return axios;
};

